const Title = ({
  title,
  size = 2,
}: {
  title: string;
  size?: 1 | 2 | 3 | 4 | 5 | 6;
}) => {
  const HeadingTag = `h${size}` as keyof JSX.IntrinsicElements;

  const sizeClassMap: { [key in 1 | 2 | 3 | 4 | 5 | 6]: string } = {
    1: "text-4xl",
    2: "text-3xl",
    3: "text-2xl",
    4: "text-xl",
    5: "text-lg",
    6: "text-base",
  };

  const textSizeClass = sizeClassMap[size];

  return (
    <HeadingTag className={`font-semibold ${textSizeClass}`}>
      {title}
    </HeadingTag>
  );
};

export default Title;
